

const directive = function () {

  return {
    restrict: 'EA',
    replace: true,
    controller: 'DataCaptureListController',
    controllerAs: 'vm',
    link: function () {},
    scope: {
      datacaptures: '=',
      onDatacaptureClicked: '=' // function with datacapture id param
    },
    bindToController: true,
    templateUrl: 'dash/topControls/dataCaptureSelector/dataCaptureList/dataCaptureList.tpl.html'
  };
};

directive.$inject = [];
module.exports = directive;



// WEBPACK FOOTER //
// ./src/app/dash/topControls/dataCaptureSelector/dataCaptureList/DataCaptureListDirective.js